export const searchUtil = <T>(
  callback: (filteredList: T[]) => void,
  unfilteredList: T[],
  properties: (keyof T)[],
  value: string
) => {
  const lowerValue = value.toLowerCase();

  const filteredList = unfilteredList.filter((l) => {
    return properties.some((name) => {
      const cell = l[name];

      if (Array.isArray(cell)) {
        return cell.some((v) => String(v).toLowerCase().includes(lowerValue));
      }

      return String(cell ?? '')
        .toLowerCase()
        .includes(lowerValue);
    });
  });

  callback(filteredList);
};
